import React, { useContext } from 'react'
import { TextField } from './carbon-entitysync'
import { EntityContext } from '@parallelpublicworks/entitysync';
import DependsOn from './DependsOn';
// import getYearDiffWithMonth from '../util/getYearDiff';
// const PROGRAM_START_DATE = process.env.PROGRAM_START_DATE || '2025-06-22';

function validateEmail(email) {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}

function validatePhone(phone){
    
  if (!/^[\d+\- ]+$/.test(phone.trim())) {
    return false;
  }
  
  const cleaned = phone.trim().replace(/(?!^\+)[^\d]/g, '');
  
  const reE164 = /^\+?[1-9]\d{7,14}$/;
  return reE164.test(cleaned);
}

function validateNumber(number){
    const re = /^[+-]?\d+(,|.\d+)?$/
    return re.test(String(number));
}

function validateminimum(number, minimum){
    const re = minimum
    return number >= re ? true : false ;
}

function validateDate(date) {
    if (!date || date.trim() === '') {
        return false;
    }
    
    const dateObj = new Date(date);
    
    if (isNaN(dateObj.getTime())) {
        return false;
    }
    
    const year = dateObj.getFullYear();
    if (year > 9999) {
        return false;
    }
    
    return true;
}

export default function TextQuestion({
    field, 
    question, 
    error, 
    setError, 
    setTouched, 
    touched, 
    required, 
    disabled = false, 
    type = 'text',
    natural
    }) {
    const number_type = question.field_number_type ? question.field_number_type : 'integer';
    let minimum = question.field_minimum ? number_type=== 'float' ? parseFloat(question.field_minimum) : parseInt(question.field_minimum) : null;
    minimum = question.type === 'textarea' ? question.field_minimum : minimum
    
    const entityContext = useContext(EntityContext);

    const onChange = (value) => {
        value = value.imaginaryTarget ? value?.imaginaryTarget?.value : value?.target?.value || value || '';
        let has_value = touchField(value)
        let is_valid = has_value && validate(value)
        if(setError && (required || has_value)) {
            if(is_valid && (type !== 'number' || type !== 'textarea')) {
                setError(false)
            } else if(type === 'number') {
                const num_val = number_type === 'float' 
                ? validateminimum(parseFloat(value),minimum) 
                : validateminimum(parseInt(value), minimum);
                if(!num_val && required){
                    setError('Please review minimum criteria')
                }else{
                    setError(false)
                }
            } else {
                switch (type) {
                    case 'email':
                        setError('Please add a valid email address')
                        break
                    case 'phone':
                        setError('Please add a valid phone number')
                        break
                    case 'date':
                        // Check specific date validation failures
                        if (value && value.trim() !== '') {
                            const dateObj = new Date(value);
                            if (isNaN(dateObj.getTime())) {
                                setError('Please enter a valid date')
                            } else if (dateObj.getFullYear() > 9999) {
                                setError('Year cannot have more than 4 digits')
                            } else {
                                setError('Please enter a valid date')
                            }

                            // if(field === "field_birthdate" && !isBirthdateValid(value)) {
                            //     setError('You must be 18 years old to apply.');
                            // }

                        } else {
                            // Only show error for required fields when empty
                            if(required) {
                                setError('Please enter a date')
                            } else {
                                setError(false)
                            }
                        }
                        break
                    default:
                        // Only show error for required fields when empty
                        if(required) {
                            setError('Please complete this field')
                        } else {
                            setError(false)
                        }
                        break
                }
            }
        } else if(setError && !has_value && !required) {
            // Clear error for optional fields when empty
            setError(false)
        }
    }

    const validate = (value) => {
        switch (type) {
            case 'email':
                return validateEmail(value)
            case 'number':
                return !isNaN(value) && validateNumber(value)
            case 'phone':
                return validatePhone(value)
            case 'date':
                let isValid = validateDate(value);
                if(!isValid) return false;

                // if(isValid && field === "field_birthdate") return isBirthdateValid(value);

                return isValid;
            default:
                return !!value
        }
    }

    const touchField = (value) => {
        let has_value = false
        switch (type) {
            case 'number':
                value = parseInt(`${value}`)
                has_value = typeof value === "number" && !isNaN(value)
                break;
            default:
                has_value = typeof value === 'string' && value.length > 0
                break;
        }
        if(!touched && has_value && setTouched) setTouched(true)
        return has_value
    }

    // const isBirthdateValid = (birthdate) => {
    //   birthdate = new Date(birthdate);
    //   let age = getYearDiffWithMonth(birthdate, new Date(PROGRAM_START_DATE));
    //   return age >= 18;
    // }

    let { field_depends_on, field_depends_on_option } = question.relationships;
    
    return (<div className={`task-question type-${type} number-type-${number_type}`}>
              <DependsOn
                dependsOn={field_depends_on}
                dependsOnOptions={field_depends_on_option}
                removeFieldError={() => setError(false)}
              >
                <TextField
                  id={question.drupal_id} 
                  light 
                  field={field} 
                  type={type} 
                  number_type={number_type} 
                  onChange={onChange} 
                  labelText={`${question.title} ${required ?  '' : '(optional)'}`} 
                  invalidText={!!error && touched ? error : ''} 
                  invalid={!!error && touched} 
                  disabled={disabled}
                  minimum={minimum} />
              </DependsOn>
            </div>)
}